import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AnalisePedidosService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  obtenhaDesempenho(inicio: any, fim: any, entregador: any = null) {
    return this.obtenha('/pedidos/analise?inicio=' + inicio + '&fim=' + fim +
      (entregador && entregador.id !== 'Todos' ? "&idEntregador=" + entregador.id : ""), {})
  }
}
